import { Component } from '@angular/core';
import { GungSettingsBaseViewComponent } from '../../gung-settings-base-view/gung-settings-base-view.component';

@Component({
    selector: 'lib-gung-settings-customer-templates',
    templateUrl: './gung-settings-customer-templates.component.html',
    styleUrl: './gung-settings-customer-templates.component.scss',
    standalone: false
})
export class GungSettingsCustomerTemplatesComponent extends GungSettingsBaseViewComponent {}
